import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import InventoryManagement from './InventoryManagement';

// The tenant is fixed by the subdomain, so this always manages the current
// tenant's inventory. To manage another tenant, open that tenant's site.
const AdminInventory = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) { navigate('/login', { replace: true }); return; }
    if (user.role !== 'ADMIN') { navigate('/unauthorized', { replace: true }); }
  }, [user, navigate]);

  if (!user || user.role !== 'ADMIN') return null;

  return <InventoryManagement />;
};

export default AdminInventory;
